import React, { useEffect, useState } from "react";
import CommonTitle from "../../components/CommonTitle";
import plant from "../../assets/icons/plantPanel.webp";
import { IS_LOCAL_ENV, socket } from "../../App";
import { getAmbients } from "../../services/labRegister";
import { getLabMeasurementsByAmbient } from "../../services/panel";
import Select from "../../components/Select";
import LoadingPage from "../../components/LoadingPage";
import livePointW from "../../assets/icons/livePointW.webm";
import Chart from "./Chart/Index";
import ControlCard from "./ControlCard/Index";
import { useNavigate } from "react-router-dom";
import Notification from "../../components/ui-elements/Notification";

//const props = ["Temperatura", "Humedad", "Luz", "Ph"];

function formatDate(dateValue) {
  const [year, month, day] = dateValue.split("-");
  return `${month}/${day}/${year}`;
}

function getDateMinus1Days() {
  const today = new Date();
  const dateMinus1Days = new Date(today);
  dateMinus1Days.setDate(today.getDate() - 1);

  const year = dateMinus1Days.getFullYear();
  const month = String(dateMinus1Days.getMonth() + 1).padStart(2, "0"); // Los meses son base 0
  const day = String(dateMinus1Days.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

const Panel = () => {
  const navigate = useNavigate();
  const [options, setOptions] = useState(null); //opciones del select de ambiente
  const [ambient, setAmbient] = useState(null); //id de ambiente elegido
  const [propsData, setPropsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [startDate, setStartDate] = useState(getDateMinus1Days()); //fecha inicial enero 2024

  const changeAmbientValue = (e) => {
    setAmbient(e.target.value);
    IS_LOCAL_ENV && console.log(e.target.value);
  };

  // const handleNewMeasurement = (props) => {
  //   if (props.data.ambient.id === ambient) {
  //     setPropsData((prevData) => {
  //       return prevData.map((item) => {
  //         if (item.property === props.data.property) {
  //           // Crear un nuevo objeto con los datos actualizados
  //           return {
  //             ...item,
  //             data: [...item.data, props.data],
  //           };
  //         }
  //         return item;
  //       });
  //     });
  //   }
  // };
  const handleNewMeasurement = (props) => {
    if (props.data.ambient.id === ambient) {
      setPropsData((prevData) => {
        return prevData.map((item) => {
          if (item.property === props.data.property) {
            // Buscar si el registro ya existe
            const recordIndex = item.data.findIndex(
              (record) => record.id === props.data.id
            );

            // Si existe, actualiza el registro en su posición original
            if (recordIndex !== -1) {
              const updatedData = [...item.data];
              updatedData[recordIndex] = {
                ...updatedData[recordIndex],
                ...props.data,
              }; // Reemplaza en la misma posición
              return { ...item, data: updatedData };
            }

            // Si es un nuevo registro, agrégalo al final
            return {
              ...item,
              data: [...item.data, props.data],
            };
          }
          return item;
        });
      });
    }
  };

  const handleRemoveMeasurement = (props) => {
    // Asegurarse de que el ambiente coincida
    if (props.data.ambient.id === ambient) {
      const measurementIdToRemove = props.data.id;
      const propertyToRemoveFrom = props.data.property;

      // Actualizar el estado de `propsData`
      setPropsData((prevData) => {
        return prevData.map((item) => {
          if (item.property === propertyToRemoveFrom) {
            // Filtrar el registro dentro del `data` de esta propiedad
            const updatedData = item.data.filter(
              (record) => record.id !== measurementIdToRemove
            );
            IS_LOCAL_ENV && console.log(updatedData);
            return { ...item, data: updatedData };
          }
          return item; // Devolver las demás propiedades sin cambios
        });
      });

      // // Notificación opcional
      // Notification({
      //   title: "Aviso",
      //   text: `Se eliminó un registro`,
      //   type: "Info",
      // });
    }
  };

  useEffect(() => {
    //para registros nuevos o actualizados
    socket.on("createdLabMeasurement", handleNewMeasurement);
    //para eliminar registros
    socket.on("deletedLabMeasurement", handleRemoveMeasurement);

    return () => {
      socket.off("createdLabMeasurement", handleNewMeasurement);
      socket.off("deletedLabMeasurement", handleRemoveMeasurement);
    };
  }, [ambient]);

  useEffect(() => {
    if (ambient != null && startDate != null && startDate != "") {
      //setLoading(true);
      const fetchPropsData = async () => {
        try {
          const response = await getLabMeasurementsByAmbient(
            ambient,
            formatDate(startDate)
          );
          IS_LOCAL_ENV && console.log(response);
          setPropsData(response);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          IS_LOCAL_ENV && console.error(err);
          Notification({
            title: "Error",
            text: `Algo salió mal...`,
            type: "Error",
          });
        }
      };
      fetchPropsData();
    }
  }, [ambient, startDate]);

  //========================CARGA DE AMBIENTES==========================
  //traigo los ambientes que estan disponibles para mostrarlos en el select
  useEffect(() => {
    const fetchAmbients = async () => {
      try {
        //obtener lista de ambientes
        const { docs } = await getAmbients();
        if (docs.length == 0) {
          Notification({
            title: "Aviso",
            text: `Aún no hay ambientes, o registros de laboratorio`,
            type: "Info",
          });
          navigate("/home");
        } else {
          const temp = docs.map(({ name, id, ...rest }) => ({
            text: name,
            value: id,
            ...rest,
          }));
          //
          setOptions(temp);
          setAmbient(temp[0].value);
        }
        //renombrar atributos (IMPORTANTE)
        //el componente customselect es generico, por lo que de acuerdo a las propiedades del objeto que se trae del back, hay que renonmbrar sus atributos para que puedan ser procesads dentro del componente select.
        //aqui se cambia name:"Ambiente 1" || "Ambiente 2" || ..., por text, y id:1adf3... || 13fas2... || ..., por value
      } catch (err) {
        Notification({
          title: "Error",
          text: `Algo salió mal...`,
          type: "Error",
        });
      }
    };
    fetchAmbients();
    //IS_LOCAL_ENV && console.log(params["*"]);
  }, []);

  return (
    <>
      <div className="w-full flex flex-col ">
        <CommonTitle
          img={plant}
          title={"Medidor para suelos"}
          text={
            "Visualiza una vista general de los procesos de medición del suelo."
          }
        >
          <div className="flex flex-col items-center gap-y-2">
            <span className="font-poppins font-bold text-default-gray text-sm">
              Fecha de inicio:
            </span>
            <div className="bg-light-purple flex flex-row rounded-full px-2 py-1 items-center font-poppins text-dark-purple  font-bold gap-x-2">
              {/* <Calendar /> */}
              <input
                //title={"Fecha de inicio"}
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                //placeholder={`ej: 12/09/24`}
                type="date"
                required={true}
                className="bg-transparent border-none outline-none focus:ring-0 w-fit"
                max={new Date(Date.now()).toISOString().split("T")[0]}
              />
              {/* <span className="text-sm">12/09/24</span> */}
            </div>
            {ambient && options && (
              <Select
                placeholder="Ambiente"
                options={options}
                setValue={changeAmbientValue}
                initialValue={ambient}
                customW="w-[155px]"
              />
            )}
          </div>
        </CommonTitle>

        <div className="flex flex-col items-center w-full justify-center md:p-6 p:1 bg-gradient-to-b from-white via-light-green-50 to-white mt-4">
          <div className="flex flex-row w-full justify-center items-center gap-x-2">
            <video
              width="40px"
              height="auto"
              loop
              autoPlay
              muted
              controls={false}
            >
              <source src={livePointW} type="video/webm" />
            </video>
            <h2 className="text-dark-green font-poppins text-xl text-nowrap">
              Panel detallado
            </h2>
          </div>
          {loading ? (
            <LoadingPage />
          ) : (
            <>
              <div className="flex flex-wrap max-w-[1280px] 2xl:max-w-full w-full justify-center ">
                {propsData.map((prop, i) => {
                  const uniqueKey = `${prop.property}-${JSON.stringify(
                    prop.data
                  )}`;
                  return (
                    <Chart
                      key={uniqueKey}
                      propInfo={{
                        ...prop,
                        data: [...prop.data], // Asegurarse de pasar una nueva referencia
                      }}
                    />
                  );
                })}
              </div>
              <div className="flex flex-row w-full justify-center items-center gap-x-2">
                <video
                  width="40px"
                  height="auto"
                  loop
                  autoPlay
                  muted
                  controls={false}
                >
                  <source src={livePointW} type="video/webm" />
                </video>
                <h2 className="text-dark-green font-poppins text-xl text-nowrap">
                  Panel absoluto
                </h2>
              </div>
              <div className="flex flex-wrap max-w-[1280px] 2xl:max-w-[1920px] w-full justify-center">
                {propsData.map((prop, i) => {
                  return <ControlCard obj={prop} key={i} showPopUp={i == 0} />;
                })}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default Panel;
